export interface Scenario {
  id: string;
  title: string;
  imageSrc: string;
  htmlDescription: string;
  aiInstructions: string;
  openingMessage: string;
  voiceName: string;
  isDefault?: boolean;
}

export const restaurantScenario: Scenario = {
  id: 'restaurant',
  title: 'Een tafel reserveren bij een restaurant',
  imageSrc: '/assets/reservering.png',
  htmlDescription: `<p>Je wilt een tafel reserveren bij restaurant “Mes en Vork”. Je belt met het restaurant. Gebruik de volgende informatie:</p>
  <img src="/assets/calendar.jpg" alt="Kalender" width="200" />
  <img src="/assets/clock.png" alt="Klok" width="200" />
  <img src="/assets/people.png" alt="4 personen" width="200" />`,
  aiInstructions: `Je werkt bij restaurant Mes en Vork. Je neemt de telefoon op. Vraag om de volgende informatie:
    -	Aantal personen
    -	Dag
    -	Tijd
    Het restaurant opent om 18:00 uur.  Vanaf 18:00 uur is er genoeg plek.`,
  openingMessage: `Met restaurant Mes en Vork, waarmee kan ik u van dienst zijn?`,
  voiceName: 'en-GB-AdaMultilingualNeural', // Ada multilingual stem voor restaurant service
};

export const huisartsScenario: Scenario = {
  id: 'huisarts',
  title: 'Huisarts',
  imageSrc: '/assets/doctor_visit.png',
  htmlDescription: `<p>Je hebt al een week lang hoofdpijn. Je belt de huisarts om een afspraak te maken. Het is vandaag maandag. Gebruik de volgende informatie:</p>
  <img src="/assets/headache.png" alt="Hoofdpijn" width="200" />
  <img src="/assets/no-medication.jpg" alt="Geen medicatie" />
  <ul>
    <li>Naam: Johan(na) Smid</li>
    <li>Geboortedatum: 20-01-2002</li>
  </ul>`,
  aiInstructions: `Je bent de assistent van huisartsenpraktijk Koningsplein. Je neemt de telefoon op. Vraag om de volgende informatie:
-	Naam
-	Geboortedatum
-	Klachten
-	Welke medicijnen gebruikt hij/zij?
Er is nog plek voor een afspraak om 10:00 uur of om 10:30 uur.
`,
  openingMessage: `Huisartsenpraktijk Koningsplein, met wie spreek ik?`,
  voiceName: 'nl-NL-ColetteNeural', // Professionele stem voor medische setting
};

export const vakantieScenario: Scenario = {
  id: 'vakantie',
  title: 'Na de vakantie',
  imageSrc: '/assets/vakantie.png',
  htmlDescription: `<p>Je bent net terug van vakantie. Je vriend/vriendin belt jou en vraagt naar je vakantie. Gebruik de volgende informatie: </p>
  <img src="/assets/italy.jpg" alt="Italië" />
  <img src="/assets/hiking.png" alt="Wandelen" />
  <img src="/assets/pizza.png" alt="Pizza" />
  <img src="/assets/swimming.png" alt="Zwemmen" />
  <img src="/assets/dining.png" alt="Uit eten" />`,
  aiInstructions: `Je vriend of vriendin is net terug van vakantie. Je belt hem/haar en vraagt hoe de vakantie was. Vraag:
- Waar hij/zij is geweest?
- Activiteiten
- Wat was het leukste?
- Heeft hij/zij lekker gegeten?
`,
  openingMessage: `Hoi! Hoe was je vakantie?`,
  voiceName: 'en-US-BrianMultilingualNeural', // Brian multilingual mannenstem voor vriendelijk gesprek
};

export const lunchScenario: Scenario = {
  id: 'lunch',
  title: 'Lunchafspraak',
  imageSrc: '/assets/lunch_appointment.png',
  htmlDescription: `<p>Je wilt met een vriend(in) afspreken voor de lunch. 
Je belt om plannen te maken. Gebruik de agenda en het volgende plaatje:
</p>
  <img src="/assets/lunchroom.jpg" alt="Lunchroom" />`,
  aiInstructions: `Neem de telefoon op. Je wordt gebeld door een vriendin. Het is vandaag maandag. Vraag bijvoorbeeld:
- Wat willen we eten?
- Waar willen we afspreken?
`,
  openingMessage: `Hoi! Met wie spreek ik?`,
  voiceName: 'en-US-EmmaMultilingualNeural', // Emma multilingual stem voor informeel gesprek
};

export const restaurantOrderScenario: Scenario = {
  id: 'restaurant-order',
  title: 'Bestelling in een restaurant',
  imageSrc: '/assets/restaurant.png',
  htmlDescription: `<p>Je bent in restaurant “Mes en Vork”. Gebruik de volgende dingen: <br/>
- Vraag naar de soep van de dag<br/>
- Bestel:</p>
  <img src="/assets/beer.png" alt="Bier" width="150" />
  <img src="/assets/soup.png" alt="Soep" width="150" />
  <img src="/assets/fish.png" alt="Vis" width="150" />
  <img src="/assets/icecream.png" alt="IJs" width="150" />
  <br/><br/>
- Zeg dat je wil betalen 
<br/>
- Betaal contant. Dit zit er in je portemonnee: <br/>
  <img src="/assets/20_euro.jpg" alt="20 euro" width="150" />
  <img src="/assets/20_euro.jpg" alt="20 euro" width="150" />
  <img src="/assets/10_euro.jpg" alt="10 euro" width="150" />

  `,
  aiInstructions: `Je werkt in restaurant “Mes en Vork”. Beantwoord de vragen van Rol A. Gebruik routinezinnen zoals:
-	Vraag wat hij/zij wil drinken
-	Vraag wat hij/zij wil eten 
-	De soep van de dag is tomatensoep
-	De gast moet €38,50 betalen
Begin niet zelf over de tomatensoep, wacht tot de gast ernaar vraagt.
Alleen als de gast erom vraagt, geef je de rekening.
`,
  openingMessage: `Welkom bij ons restaurant, wat mag ik voor u doen?`,
  voiceName: 'nl-NL-ColetteNeural', // Professionele vrouwenstem voor service
};

export const stationScenario: Scenario = {
  id: 'train-station',
  title: 'Treinstation',
  imageSrc: '/assets/train_station.png',
  htmlDescription: `<p>Je werkt in het station. Iemand vraagt jou om de weg.<br/> Gebruik de volgende informatie:</p>
    <img src="/assets/train-schedule.jpg" alt="Treinschema" />`,
  aiInstructions: `Jullie bevinden je op station Enschede. Jij probeert in Eindhoven te komen en vraagt aan de ander om hulp.`,
  openingMessage: `Hallo, mag ik jou misschien wat vragen?`,
  voiceName: 'nl-NL-MaartenNeural', // Casual mannenstem voor hulpvraag
  isDefault: true
};

export const scenarios: Record<string, Scenario> = {
  [restaurantScenario.id]: restaurantScenario,
  [stationScenario.id]: stationScenario,
  [huisartsScenario.id]: huisartsScenario,  
  [vakantieScenario.id]: vakantieScenario,
  [lunchScenario.id]: lunchScenario,
  [restaurantOrderScenario.id]: restaurantOrderScenario,
};

export const scenarioList: Scenario[] = Object.values(scenarios);

export const getDefaultScenario = (): Scenario => {
  const fallback = scenarioList[0];
  return scenarioList.find((scenario) => scenario.isDefault) ?? fallback;
};
